var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2969_118737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7812 70.1543L47.9481 65.4136H42.0557L41.2226 70.1543C40.3425 75.1624 37.6588 79.4993 33.844 82.0784C32.8468 82.7527 33.2602 84.5185 34.4154 84.5185H55.5882C56.7434 84.5185 57.157 82.7527 56.1596 82.0784C52.345 79.4993 49.6612 75.1624 48.7812 70.1543Z",
    fill: "url(#paint0_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1572 82.0784C52.3424 79.4991 49.6588 75.1624 48.7786 70.1543L47.9455 65.4136H45.1846L44.3515 70.1543C43.4714 75.1624 40.7877 79.4993 36.9729 82.0784C35.9757 82.7527 36.3891 84.5185 37.5443 84.5185H55.5856C56.741 84.5185 57.1544 82.7527 56.1572 82.0784Z",
    fill: "url(#paint1_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1595 82.0784C52.3447 79.4991 49.6612 75.1622 48.7809 70.1543L47.9478 65.4136H42.0554L41.5156 68.4856L56.6598 83.6298C56.8174 83.0875 56.6833 82.4326 56.1595 82.0784Z",
    fill: "url(#paint2_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1938 68.4856H2.80624C1.25647 68.4856 0 67.2291 0 65.6794V8.28776C0 6.73782 1.25647 5.48153 2.80624 5.48153H87.1936C88.7435 5.48153 89.9998 6.738 89.9998 8.28776V65.6794C90 67.2291 88.7435 68.4856 87.1938 68.4856Z",
    fill: "url(#paint3_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7756 67.0636H4.22258C2.73405 67.0636 1.52734 65.8569 1.52734 64.3684V9.59876C1.52734 8.11023 2.73405 6.90353 4.22258 6.90353H85.7755C87.264 6.90353 88.4707 8.11023 88.4707 9.59876V64.3682C88.4709 65.8569 87.2642 67.0636 85.7756 67.0636Z",
    fill: "url(#paint4_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9985 65.6794V45.4216L71.6046 27.0277C67.5359 22.7308 61.778 20.0501 55.3933 20.0501C43.0647 20.0501 33.0703 30.0445 33.0703 42.3731C33.0703 48.7576 35.7513 54.5156 40.048 58.5844L49.9494 68.4858H87.1921C88.742 68.4856 89.9985 67.2291 89.9985 65.6794Z",
    fill: "url(#paint5_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3966 64.3262H6.59993C5.35387 64.3262 4.34375 63.3161 4.34375 62.07V11.8971C4.34375 10.6511 5.35387 9.64076 6.59993 9.64076H83.3966C84.6426 9.64076 85.6529 10.6509 85.6529 11.8971V62.07C85.6529 63.3161 84.6428 64.3262 83.3966 64.3262Z",
    fill: "url(#paint6_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6454 9.64094H6.59993C5.35387 9.64094 4.34375 10.6511 4.34375 11.8973V62.07C4.34375 63.3161 5.35387 64.3262 6.59993 64.3262H11.6454V9.64094Z",
    fill: "url(#paint7_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3966 9.64094H6.59993C5.35387 9.64094 4.34375 10.6511 4.34375 11.8973V15.9836H85.6529V11.8971C85.6529 10.6511 84.6428 9.64094 83.3966 9.64094Z",
    fill: "url(#paint8_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.657 40.9129V62.07C85.657 63.4024 84.6052 64.3271 83.2376 64.3271H45.7941L40.0517 58.5847C40.0517 58.5847 40.0499 58.5847 40.0499 58.5829C39.9299 58.47 39.8117 58.3553 39.6952 58.2388C39.577 58.1224 39.4605 58.0059 39.3458 57.8859C39.2488 57.7853 39.1517 57.6829 39.0547 57.5788C39.0335 57.5576 39.0141 57.5365 38.9947 57.5135C38.8941 57.4041 38.7935 57.2947 38.6947 57.1835C38.6858 57.1747 38.6788 57.1659 38.6717 57.1571C38.5623 57.0335 38.4547 56.9082 38.347 56.7812C38.3452 56.7812 38.3452 56.7794 38.3435 56.7776C38.2482 56.6629 38.1511 56.5482 38.0576 56.4318C38.0382 56.4088 38.0205 56.3876 38.0029 56.3647C37.9217 56.2624 37.8405 56.16 37.7594 56.0576C37.7294 56.0206 37.6994 55.9818 37.6711 55.9429C37.5882 55.8335 37.5052 55.7241 37.4241 55.6129C37.3252 55.4788 37.2282 55.3447 37.1329 55.2088C37.0376 55.0747 36.9423 54.9371 36.8505 54.7994C36.7676 54.6776 36.6864 54.5541 36.607 54.4288C36.5911 54.4041 36.5752 54.3794 36.5594 54.3547C36.3917 54.0918 36.2294 53.8235 36.0705 53.5518C36.0564 53.5288 36.0441 53.5076 36.0317 53.4847C35.9594 53.3559 35.8852 53.2271 35.8147 53.0947C35.7335 52.95 35.6558 52.8018 35.5782 52.6535C35.5005 52.5053 35.4264 52.3571 35.3523 52.2071C35.287 52.0747 35.2235 51.9406 35.1599 51.8065C35.1494 51.7853 35.1405 51.7659 35.1317 51.7447C35.0647 51.6018 34.9994 51.4571 34.9358 51.3106C34.9305 51.3 34.9252 51.2894 34.9217 51.2771C34.8582 51.1306 34.7947 50.9806 34.7329 50.8306C34.7294 50.8235 34.7258 50.8165 34.7241 50.8112C34.6641 50.6629 34.6041 50.5129 34.5476 50.3629C34.5388 50.3435 34.5317 50.3241 34.5247 50.3029C34.4717 50.1653 34.4205 50.0259 34.3711 49.8882C34.3147 49.7294 34.2599 49.5688 34.207 49.4082C34.1523 49.2476 34.1011 49.0871 34.0517 48.9247C34.0023 48.7623 33.9547 48.6 33.9088 48.4359C33.8629 48.2753 33.8188 48.1129 33.7764 47.9506C33.7764 47.9488 33.7747 47.9453 33.7747 47.9418C33.7341 47.7794 33.6935 47.6153 33.6547 47.4494C33.6511 47.4371 33.6476 47.4265 33.6458 47.4141C33.6105 47.2571 33.5752 47.1 33.5435 46.9429C33.5082 46.7735 33.4747 46.6059 33.4447 46.4365C33.4129 46.2671 33.3847 46.0976 33.3564 45.9282V45.9247C33.3299 45.7535 33.3035 45.5823 33.2805 45.4112C33.2347 45.0671 33.1958 44.7212 33.1641 44.3718L39.7888 40.0112C39.6723 40.7806 39.6123 41.5694 39.6123 42.3724C39.6123 51.09 46.6782 58.1576 55.3958 58.1576C64.1135 58.1576 71.1811 51.09 71.1811 42.3724C71.1811 35.0365 66.1782 28.8724 59.3964 27.1006L66.0229 22.7382C66.1535 22.8071 66.2823 22.8794 66.4111 22.9535C66.7976 23.1741 67.1752 23.4053 67.5476 23.6453C67.7947 23.8059 68.04 23.9718 68.2799 24.1429C68.2941 24.15 68.3064 24.1606 68.3188 24.1694C68.4247 24.2453 68.5288 24.3212 68.6329 24.3971C68.6364 24.3988 68.6399 24.4006 68.6435 24.4041C68.7529 24.4853 68.8605 24.5665 68.9664 24.6476C69.4429 25.0112 69.9017 25.3941 70.3464 25.7965C70.4329 25.8741 70.5176 25.9518 70.6023 26.0312C70.6394 26.0647 70.6747 26.0982 70.7099 26.1318C70.8035 26.22 70.897 26.31 70.9888 26.4H70.9905C71.0964 26.5041 71.1988 26.6065 71.3011 26.7106C71.3876 26.7971 71.4705 26.8835 71.5552 26.9718C71.5729 26.9894 71.5905 27.0088 71.6082 27.0282L85.657 40.9129Z",
    fill: "url(#paint9_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8286 61.6969H9.17378C8.03801 61.6969 7.11719 60.7761 7.11719 59.6404V14.3266C7.11719 13.1908 8.03801 12.27 9.17378 12.27H80.8286C81.9644 12.27 82.8852 13.1908 82.8852 14.3266V59.6404C82.8852 60.7763 81.9644 61.6969 80.8286 61.6969Z",
    fill: "url(#paint10_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6401 54.1452H9.72233C9.34274 54.1452 9.03516 53.8375 9.03516 53.4581V51.7444C9.03516 51.3648 9.34292 51.0572 9.72233 51.0572H21.6401C22.0197 51.0572 22.3273 51.3649 22.3273 51.7444V53.4581C22.3275 53.8375 22.0197 54.1452 21.6401 54.1452Z",
    fill: "url(#paint11_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1512 54.1452H25.7341C25.3545 54.1452 25.0469 53.8375 25.0469 53.4581V51.7444C25.0469 51.3648 25.3546 51.0572 25.7341 51.0572H28.1512C28.5308 51.0572 28.8383 51.3649 28.8383 51.7444V53.4581C28.8383 53.8375 28.5308 54.1452 28.1512 54.1452Z",
    fill: "url(#paint12_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3342 59.0156H9.72233C9.34274 59.0156 9.03516 58.7079 9.03516 58.3285V56.6148C9.03516 56.2352 9.34292 55.9276 9.72233 55.9276H17.3342C17.7138 55.9276 18.0214 56.2354 18.0214 56.6148V58.3285C18.0214 58.7081 17.7138 59.0156 17.3342 59.0156Z",
    fill: "url(#paint13_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1508 59.0156H21.3473C20.9677 59.0156 20.6602 58.7079 20.6602 58.3285V56.6148C20.6602 56.2352 20.9679 55.9276 21.3473 55.9276H28.1508C28.5304 55.9276 28.838 56.2354 28.838 56.6148V58.3285C28.838 58.7081 28.5304 59.0156 28.1508 59.0156Z",
    fill: "url(#paint14_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9212 41.0416H11.0785C9.94998 41.0416 9.03516 40.1268 9.03516 38.9982V29.8091C9.03516 28.6805 9.94998 27.7657 11.0785 27.7657H78.9212C80.0498 27.7657 80.9646 28.6805 80.9646 29.8091V38.9982C80.9646 40.1268 80.0498 41.0416 78.9212 41.0416Z",
    fill: "url(#paint15_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2774 29.8542H76.7251C77.6248 29.8542 78.3541 30.5836 78.3541 31.4832V37.3237C78.3541 38.2234 77.6248 38.9527 76.7251 38.9527H13.2774C12.3778 38.9527 11.6484 38.2234 11.6484 37.3237V31.4832C11.6484 30.5836 12.3778 29.8542 13.2774 29.8542Z",
    fill: "url(#paint16_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4745 84.5185H32.5258C31.7522 84.5185 31.125 83.8913 31.125 83.1176C31.125 82.344 31.7522 81.7168 32.5258 81.7168H57.4745C58.2482 81.7168 58.8754 82.344 58.8754 83.1176C58.8754 83.8913 58.2482 84.5185 57.4745 84.5185Z",
    fill: "url(#paint17_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3527 27.7655H61.3789C66.7388 29.9633 70.621 35.0204 71.1236 41.0416H78.9215C80.05 41.0416 80.9648 40.1268 80.9648 38.9982V36.2772L72.3527 27.7655Z",
    fill: "url(#paint18_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3941 58.1576C64.1118 58.1576 71.1789 51.0906 71.1789 42.3729C71.1789 33.6552 64.1118 26.5881 55.3941 26.5881C46.6765 26.5881 39.6094 33.6552 39.6094 42.3729C39.6094 51.0906 46.6765 58.1576 55.3941 58.1576Z",
    fill: "url(#paint19_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6868 59.9649L72.9875 63.6642L68.1523 58.8291L71.8517 55.1298L76.6868 59.9649Z",
    fill: "url(#paint20_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8517 55.1298L68.1523 58.8291L69.2232 59.9001H76.6219L71.8517 55.1298Z",
    fill: "url(#paint21_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3933 20.0501C43.0647 20.0501 33.0703 30.0445 33.0703 42.3731C33.0703 54.7016 43.0647 64.6961 55.3933 64.6961C67.7219 64.6961 77.7163 54.7016 77.7163 42.3731C77.7163 30.0443 67.7219 20.0501 55.3933 20.0501ZM55.3933 58.1576C46.6757 58.1576 39.6085 51.0905 39.6085 42.3729C39.6085 33.6552 46.6757 26.5881 55.3933 26.5881C64.111 26.5881 71.1781 33.6552 71.1781 42.3729C71.1781 51.0905 64.111 58.1576 55.3933 58.1576Z",
    fill: "url(#paint22_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3952 60.1549C65.2159 60.1549 73.177 52.1936 73.177 42.3731C73.177 32.5523 65.2158 24.5912 55.3952 24.5912C45.5744 24.5912 37.6133 32.5525 37.6133 42.3731C37.6133 52.1936 45.5744 60.1549 55.3952 60.1549ZM55.3952 26.5883C64.1128 26.5883 71.1799 33.6554 71.1799 42.3731C71.1799 51.0907 64.1128 58.1578 55.3952 58.1578C46.6775 58.1578 39.6104 51.0907 39.6104 42.3731C39.6104 33.6554 46.6775 26.5883 55.3952 26.5883Z",
    fill: "url(#paint23_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2283 26.6384L66.6051 31.2616C69.4325 34.1141 71.1794 38.0393 71.1794 42.3729C71.1794 51.0905 64.1123 58.1576 55.3946 58.1576C51.061 58.1576 47.1358 56.4108 44.2833 53.5834L39.6602 58.2065C43.6959 62.2172 49.2556 64.6957 55.3948 64.6957C67.7234 64.6957 77.7178 54.7013 77.7178 42.3727C77.7176 36.2338 75.2389 30.6741 71.2283 26.6384Z",
    fill: "url(#paint24_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0497 76.9781C88.2324 76.9781 90.0018 75.2087 90.0018 73.026C90.0018 70.8433 88.2324 69.0739 86.0497 69.0739C83.8671 69.0739 82.0977 70.8433 82.0977 73.026C82.0977 75.2087 83.8671 76.9781 86.0497 76.9781Z",
    fill: "url(#paint25_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0484 76.3244C87.8701 76.3244 89.3468 74.8477 89.3468 73.026C89.3468 71.2043 87.8701 69.7276 86.0484 69.7276C84.2268 69.7276 82.75 71.2043 82.75 73.026C82.75 74.8477 84.2268 76.3244 86.0484 76.3244Z",
    fill: "url(#paint26_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7994 74.2758C89.6117 73.7111 89.2935 73.1804 88.844 72.7309C87.3006 71.1875 84.7983 71.1875 83.255 72.7309C82.8056 73.1804 82.4874 73.7111 82.2996 74.2758C81.8427 72.9012 82.1609 71.3255 83.255 70.2316C84.7985 68.6882 87.3006 68.6882 88.844 70.2316C89.9382 71.3255 90.2565 72.9012 89.7994 74.2758Z",
    fill: "url(#paint27_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2552 75.8206C81.7118 74.2772 81.7118 71.7748 83.2552 70.2316C84.7986 68.6882 87.301 68.6882 88.8442 70.2316C89.5162 70.9036 89.8953 71.7574 89.9821 72.6346L85.658 76.9586C84.781 76.8716 83.9272 76.4926 83.2552 75.8206Z",
    fill: "url(#paint28_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3126 75.8778L88.9016 70.2888L77.1642 58.5513C76.8506 58.2378 76.342 58.2378 76.0283 58.5513L71.575 63.0046C71.2614 63.3182 71.2614 63.8268 71.575 64.1405L83.3126 75.8778Z",
    fill: "url(#paint29_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.575 63.0046L74.6906 59.889C75.0042 59.5754 75.5128 59.5754 75.8264 59.889L87.5638 71.6264L83.3124 75.8778L71.575 64.1404C71.2614 63.8268 71.2614 63.3182 71.575 63.0046Z",
    fill: "url(#paint30_linear_2969_118737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3929 21.3432C43.7785 21.3432 34.3633 30.7585 34.3633 42.3729C34.3633 53.9873 43.7785 63.4025 55.3929 63.4025C67.0073 63.4025 76.4226 53.9873 76.4226 42.3729C76.4226 30.7586 67.0073 21.3432 55.3929 21.3432ZM55.3929 58.1576C46.6753 58.1576 39.6082 51.0905 39.6082 42.3729C39.6082 33.6552 46.6753 26.5881 55.3929 26.5881C64.1106 26.5881 71.1777 33.6552 71.1777 42.3729C71.1777 51.0905 64.1106 58.1576 55.3929 58.1576Z",
    fill: "url(#paint31_linear_2969_118737)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2969_118737",
    x1: 36.9797,
    y1: 74.5684,
    x2: 49.7659,
    y2: 75.7862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2969_118737",
    x1: 48.1056,
    y1: 76.2642,
    x2: 27.4585,
    y2: 71.3231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC3D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "#C5C9D7",
    stopOpacity: 0.221
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5343,
    stopColor: "#D7DAE3",
    stopOpacity: 0.534
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9014,
    stopColor: "#F6F6F8",
    stopOpacity: 0.901
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2969_118737",
    x1: 57.5476,
    y1: 79.7317,
    x2: 39.3122,
    y2: 61.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555A66",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2969_118737",
    x1: 39.5082,
    y1: 23.0898,
    x2: 68.8114,
    y2: 97.2244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2969_118737",
    x1: 82.0579,
    y1: 74.0423,
    x2: -23.9833,
    y2: -31.9989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2969_118737",
    x1: 91.2153,
    y1: 78.195,
    x2: 62.6456,
    y2: 49.6253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555A66",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2969_118737",
    x1: 40.1535,
    y1: 24.7265,
    x2: 66.0045,
    y2: 90.1272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A98F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2969_118737",
    x1: 9.35128,
    y1: 36.9836,
    x2: 2.29034,
    y2: 36.9836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0469BC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2969_118737",
    x1: 44.9983,
    y1: 14.9248,
    x2: 44.9983,
    y2: 7.46064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0469BC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2969_118737",
    x1: 87.1305,
    y1: 68.9079,
    x2: 58.1177,
    y2: 45.0843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0469BC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2969_118737",
    x1: 56.8962,
    y1: 62.5712,
    x2: 8.98388,
    y2: -40.4938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65E1DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2969_118737",
    x1: 9.03516,
    y1: 52.6011,
    x2: 22.3275,
    y2: 52.6011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2969_118737",
    x1: 25.0467,
    y1: 52.6011,
    x2: 28.8383,
    y2: 52.6011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2969_118737",
    x1: 9.03516,
    y1: 57.4717,
    x2: 18.0214,
    y2: 57.4717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2969_118737",
    x1: 20.66,
    y1: 57.4717,
    x2: 28.838,
    y2: 57.4717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2969_118737",
    x1: 44.9999,
    y1: 28.8235,
    x2: 44.9999,
    y2: 43.3876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2969_118737",
    x1: 45.0014,
    y1: 39.5294,
    x2: 45.0014,
    y2: 27.9515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2969_118737",
    x1: 45.0002,
    y1: 82.5402,
    x2: 45.0002,
    y2: 84.0697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2969_118737",
    x1: 85.2141,
    y1: 45.6055,
    x2: 66.3907,
    y2: 29.9584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2969_118737",
    x1: 64.3903,
    y1: 52.6982,
    x2: 46.5057,
    y2: 32.1715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EDF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2969_118737",
    x1: 71.5291,
    y1: 60.2998,
    x2: 74.5863,
    y2: 57.2427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2969_118737",
    x1: 75.3156,
    y1: 59.1272,
    x2: 69.2583,
    y2: 57.0418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555A66",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2969_118737",
    x1: 47.5771,
    y1: 34.5566,
    x2: 76.7198,
    y2: 63.6994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2969_118737",
    x1: 49.1689,
    y1: 36.1466,
    x2: 66.3282,
    y2: 53.3059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2969_118737",
    x1: 60.4727,
    y1: 53.5417,
    x2: 42.1664,
    y2: 0.775942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2969_118737",
    x1: 85.9893,
    y1: 75.0014,
    x2: 85.9893,
    y2: 67.7638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#808797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E8595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2969_118737",
    x1: 86.652,
    y1: 76.5313,
    x2: 85.7223,
    y2: 71.4613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E8595",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2969_118737",
    x1: 87.4709,
    y1: 73.5474,
    x2: 92.6111,
    y2: 77.3192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E8595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2969_118737",
    x1: 86.8754,
    y1: 73.7966,
    x2: 85.3946,
    y2: 72.3158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E8595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2969_118737",
    x1: 81.3293,
    y1: 65.5658,
    x2: 76.7105,
    y2: 70.1846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2969_118737",
    x1: 77.3423,
    y1: 68.3913,
    x2: 86.7007,
    y2: 65.4004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2969_118737",
    x1: 54.4255,
    y1: 39.966,
    x2: 46.7033,
    y2: 20.7524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCEE21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2969_118737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.babad13228f39727c36963949559f2f6.svg";
export { ForwardRef as ReactComponent };